
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Privacy() {
  const sections = [
    {
      title: '信息收集',
      icon: 'ri-information-line',
      content: [
        {
          subtitle: '我们收集的信息类型',
          items: [
            '账户信息：注册时提供的用户名、邮箱地址、手机号码等',
            '个人资料：头像、昵称、生日、地区等可选信息',
            '使用数据：观看记录、搜索历史、收藏内容、评论互动等',
            '设备信息：IP地址、设备类型、操作系统、浏览器类型等',
            '位置信息：用于提供本地化内容和服务（需要您的授权）'
          ]
        },
        {
          subtitle: '信息收集方式',
          items: [
            '您主动提供的信息：注册、使用服务时主动填写的信息',
            '自动收集的信息：通过Cookie、日志文件等技术自动收集',
            '第三方提供的信息：通过第三方登录获得的公开信息'
          ]
        }
      ]
    },
    {
      title: '信息使用',
      icon: 'ri-settings-line',
      content: [
        {
          subtitle: '我们如何使用您的信息',
          items: [
            '提供和改进服务：为您提供直播、回放等核心服务功能',
            '个性化推荐：根据您的兴趣推荐相关体育内容',
            '账户管理：验证身份、保障账户安全、处理客服请求',
            '通信联系：发送服务通知、营销信息（需要您的同意）',
            '数据分析：分析用户行为以优化产品功能和用户体验',
            '法律合规：遵守相关法律法规要求'
          ]
        }
      ]
    },
    {
      title: '信息共享',
      icon: 'ri-share-line',
      content: [
        {
          subtitle: '我们不会出售您的个人信息',
          items: [
            '服务提供商：为提供服务而必须的技术支持、数据分析等合作伙伴',
            '业务转让：在企业合并、收购或资产转让时可能涉及信息转移',
            '法律要求：根据法律法规、政府部门要求或法院命令',
            '安全保护：为保护用户、公众或平台合法权益而必要的情况'
          ]
        },
        {
          subtitle: '第三方服务',
          items: [
            '支付服务：使用第三方支付时，会向支付机构提供必要信息',
            '社交分享：您选择分享内容到第三方平台时的信息传输',
            '广告服务：可能向广告合作伙伴提供匿名化的用户画像'
          ]
        }
      ]
    },
    {
      title: '信息安全',
      icon: 'ri-shield-check-line',
      content: [
        {
          subtitle: '安全措施',
          items: [
            '技术保护：采用加密传输、安全存储等技术措施保护数据安全',
            '访问控制：严格限制员工对个人信息的访问权限',
            '安全培训：定期对员工进行数据安全和隐私保护培训',
            '安全审计：定期进行安全评估和漏洞检测',
            '事件响应：建立完善的安全事件应急响应机制'
          ]
        },
        {
          subtitle: '数据泄露应对',
          items: [
            '及时通知：发现数据泄露时会及时通知相关用户和监管部门',
            '影响评估：评估泄露的范围和可能造成的影响',
            '补救措施：采取必要措施减少损失，防止进一步泄露'
          ]
        }
      ]
    },
    {
      title: '您的权利',
      icon: 'ri-user-settings-line',
      content: [
        {
          subtitle: '个人信息权利',
          items: [
            '查询权：您有权查询我们收集和使用您个人信息的情况',
            '更正权：发现信息错误时，您有权要求我们更正',
            '删除权：在特定情况下，您有权要求我们删除您的个人信息',
            '撤回同意：您可以随时撤回对信息处理的同意',
            '数据携带：在技术可行的情况下，协助您将数据转移到其他服务商'
          ]
        },
        {
          subtitle: '如何行使权利',
          items: [
            '个人中心：在"隐私设置"中管理您的信息和权限',
            '联系客服：通过客服热线、邮件等方式联系我们',
            '书面申请：向我们的法务部门发送书面申请'
          ]
        }
      ]
    },
    {
      title: 'Cookie使用',
      icon: 'ri-database-line',
      content: [
        {
          subtitle: 'Cookie类型',
          items: [
            '必需Cookie：保证网站正常运行的必要Cookie',
            '功能Cookie：记住您的偏好设置，提供个性化功能',
            '分析Cookie：帮助我们了解用户如何使用网站，优化用户体验',
            '广告Cookie：用于投放个性化广告（需要您的同意）'
          ]
        },
        {
          subtitle: 'Cookie管理',
          items: [
            '浏览器设置：您可以通过浏览器设置管理Cookie',
            '隐私设置：在我们的隐私设置中选择接受或拒绝特定类型的Cookie',
            '影响说明：禁用Cookie可能影响网站的某些功能'
          ]
        }
      ]
    },
    {
      title: '未成年人保护',
      icon: 'ri-shield-user-line',
      content: [
        {
          subtitle: '特殊保护',
          items: [
            '年龄限制：我们的服务主要面向18岁以上用户',
            '监护人同意：14岁以下儿童使用服务需要监护人同意',
            '信息收集限制：对未成年人的信息收集采用更严格的标准',
            '内容过滤：提供适合未成年人的内容过滤功能'
          ]
        }
      ]
    },
    {
      title: '跨境传输',
      icon: 'ri-global-line',
      content: [
        {
          subtitle: '数据存储和传输',
          items: [
            '境内存储：您的个人信息主要存储在中国境内的服务器',
            '跨境需求：因业务需要可能向境外传输数据时，会确保符合相关法规',
            '安全保障：跨境传输时采用加密等安全措施保护数据',
            '用户知情：重要的跨境传输会事先获得您的同意'
          ]
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-blue-600 to-purple-600 py-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              隐私政策
            </h1>
            <p className="text-blue-100 text-lg mb-6 max-w-3xl mx-auto">
              我们重视并承诺保护您的个人隐私，本政策说明我们如何收集、使用和保护您的个人信息
            </p>
            <div className="flex items-center justify-center space-x-4 text-blue-100">
              <div className="flex items-center">
                <i className="ri-calendar-line mr-2"></i>
                <span className="text-sm">最后更新：2024年3月15日</span>
              </div>
              <div className="w-1 h-4 bg-blue-300"></div>
              <div className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                <span className="text-sm">生效日期：2024年3月20日</span>
              </div>
            </div>
          </div>
        </section>

        {/* 导言 */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="bg-blue-50 rounded-lg p-6 mb-8">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-3">重要提示</h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      贝斯特体育（以下简称"我们"）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：
                    </p>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>权责一致原则：收集的个人信息用途与服务功能相匹配</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>目的明确原则：明确告知收集和使用个人信息的目的</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>选择同意原则：为您提供相应的选择和控制机制</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>最少够用原则：只收集实现服务功能所必需的信息</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>确保安全原则：使用各种合理的安全措施保护个人信息</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>主体参与原则：保障您对个人信息的知情权和决定权</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>公开透明原则：努力确保您可以简单了解我们的个人信息处理规则</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="prose max-w-none">
                <p className="text-gray-600 leading-relaxed mb-6">
                  本隐私政策适用于贝斯特体育网站（bstyx.com）及相关移动应用程序。在使用我们的产品或服务前，请您仔细阅读并充分理解本政策，特别是以<strong className="text-red-600">粗体</strong>标识的条款。如果您不同意本政策的任何内容，请您停止使用我们的产品或服务。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 详细条款 */}
        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto space-y-8">
              {sections.map((section, index) => (
                <div key={index} className="bg-white rounded-lg shadow-sm">
                  <div className="p-6 border-b border-gray-100">
                    <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                      <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                        <i className={`${section.icon} text-blue-600`}></i>
                      </div>
                      {index + 1}. {section.title}
                    </h2>
                  </div>
                  
                  <div className="p-6 space-y-6">
                    {section.content.map((item, itemIndex) => (
                      <div key={itemIndex}>
                        <h3 className="font-medium text-gray-900 mb-3">{item.subtitle}</h3>
                        <ul className="space-y-2">
                          {item.items.map((listItem, listIndex) => (
                            <li key={listIndex} className="flex items-start text-gray-700">
                              <i className="ri-arrow-right-circle-line text-blue-500 mr-3 mt-0.5 flex-shrink-0"></i>
                              <span className="leading-relaxed">{listItem}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 联系方式 */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg p-8 text-white">
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <i className="ri-customer-service-line mr-3"></i>
                  联系我们
                </h2>
                <p className="text-blue-100 mb-6">
                  如果您对本隐私政策有任何疑问、意见或建议，或者您需要行使相关权利，请通过以下方式联系我们：
                </p>
                
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-blue-200"></i>
                      <div>
                        <div className="font-medium">邮箱</div>
                        <div className="text-blue-100">privacy@bstyx.com</div>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-phone-line mr-3 text-blue-200"></i>
                      <div>
                        <div className="font-medium">客服热线</div>
                        <div className="text-blue-100">400-888-8888</div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <i className="ri-map-pin-line mr-3 text-blue-200 mt-0.5"></i>
                      <div>
                        <div className="font-medium">通讯地址</div>
                        <div className="text-blue-100">北京市朝阳区体育大厦<br />贝斯特体育法务部</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-6 pt-6 border-t border-blue-400">
                  <p className="text-blue-100 text-sm">
                    我们承诺在收到您的问题后15个工作日内回复。为了更好地保护您的权益，我们可能会在处理您的请求前验证您的身份。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 政策更新 */}
        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                  <i className="ri-refresh-line text-green-600 mr-3"></i>
                  政策更新
                </h2>
                <div className="prose max-w-none text-gray-700">
                  <p className="mb-4">
                    我们可能会不定期修订本隐私政策。当隐私政策发生变更时，我们会在网站显著位置提示政策变更。对于重大变更，我们还会通过站内信、邮件等方式通知您。
                  </p>
                  <p className="mb-4">
                    <strong>重大变更包括但不限于：</strong>
                  </p>
                  <ul className="list-disc list-inside space-y-1 mb-4">
                    <li>服务模式发生重大变化</li>
                    <li>个人信息共享、转让或公开披露的主要对象发生变化</li>
                    <li>您参与个人信息处理方面的权利及其行使方式发生重大变化</li>
                    <li>负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化</li>
                  </ul>
                  <p>
                    我们建议您定期查阅本政策，以了解最新的隐私保护措施。如果您继续使用我们的服务，即表示您同意接受修订后的隐私政策。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
